export const resolveMerchantLevel = (merchantLevel: number): string => {
  switch (merchantLevel) {
    case 1:
      return 'Abuelo';
    case 2:
      return 'Padre';
    case 3:
      return 'Hijo';
    default:
      return '';
  }
};
